<template>
  <div class="l-container container">
    <div>
      <div class="step">
        <Step :currentStep="1" :steps="steps" />
      </div>
      <div class="title">
        <h1>申込者情報</h1>
      </div>
    </div>

    <a-divider />
    <div class="box">
      <div class="box-content">
        <div>
          <Item :data="dataItemOrder" />
        </div>
        <div>
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[0]"
          />
          <div class="menu-content1">
            <div class="items-content pb-2">
              <div class="item-content gap-3">
                <p>宿泊期間</p>
                <span class="mr-2" v-if="stayDay">{{ stayDay }}</span>
                <span class="mr-2" v-if="nightCnt">{{ nightCnt }} 泊</span>
                <span class="mr-2" v-if="stayRoom">{{ stayRoom }} 部屋</span>
                <span class="mr-2"
                  >（大人{{ totalAdult | formatInteger }}名/子ども{{
                    totalChild | formatInteger
                  }}名）</span
                >
              </div>
              <!-- <div class="item-content gap-3">
                <p>チェックイン</p>
                <span class="mr-2">{{checkinTime}}:00</span>
              </div> -->
            </div>
          </div>
        </div>
        <a-divider />

        <div class="menu-content2">
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[1]"
          />
          <div class="content">
            <table class="table-common">
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold">会員ID</div>
                </td>
                <td class="data">
                  <span wovn-ignore> {{ info_person_form.memberId }} </span>
                </td>
              </tr>
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold">申込者名</div>
                </td>
                <td class="data">
                  <span class="" wovn-ignore>{{ info_person_form.familyName }}</span>
                  <span wovn-ignore>{{ info_person_form.firstName }}</span>
                </td>
              </tr>
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">ご住所</div>
                  <div v-if="!selectedWebRadio" class="ml-4 category">必須</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data">郵便番号</div>
                    <div class="content-data">
                      <div class="flex mt-3 gap-2">
                        <a-input
                          :maxLength="3"
                          placeholder=""
                          @keypress="validateNumber($event)"
                          v-model="zipCode1"
                          wovn-ignore
                          :disabled="selectedWebRadio"
                          ref="zipCode1"
                        />
                        <span class="self-center">−</span>
                        <a-input
                          :maxLength="4"
                          placeholder=""
                          @keypress="validateNumber($event)"
                          v-model="zipCode2"
                          wovn-ignore
                          :disabled="selectedWebRadio"
                        />
                        <button @click="loadLocation()" class="c-btn-cm btn-white">
                          住所自動入力
                        </button>
                      </div>
                      <div>※海外在住の方は「000-0000」とご入力ください。</div>
                      <div v-if="!isForeign" class="text-primary font-bold">
                        {{ error_message_zipcode }}
                      </div>
                    </div>
                  </div>
                  <div v-if="!isForeign">
                    <div class="items-data">
                      <div class="label-data">都道府県</div>
                      <div class="content-data input-items">
                        <div class="mt-3">
                          <a-select
                            class="select-items"
                            placeholder="選択してください "
                            v-model="prefectures"
                            wovn-ignore
                            :disabled="selectedWebRadio"
                          >
                            <a-select-option v-for="(item, index) in getPrefecturesList" :key="index" :value="item.value" wovn-ignore>{{ item.label }}</a-select-option>
                          </a-select>
                        </div>
                        <div class="text-primary font-bold">
                          {{ error_message_prefectures }}
                        </div>
                      </div>
                    </div>
                    <div class="items-data">
                      <div class="label-data">市区町村・番地</div>
                      <div class="content-data input-items">
                        <div class="mt-3">
                          <a-input
                            :maxLength="100"
                            @blur="checkMessageError"
                            placeholder=""
                            v-model.trim="cityAddress"
                            wovn-ignore
                            :disabled="selectedWebRadio"
                          />
                        </div>
                        <div class="text-primary font-bold">
                          {{ error_message_cityAddress }}
                        </div>
                      </div>
                    </div>
                    <div class="items-data">
                      <div class="label-data">建物・号室（任意）</div>
                      <div class="content-data input-items">
                        <div class="mt-3">
                          <a-input
                            placeholder=""
                            :maxLength="100"
                            v-model.trim="info_person_form.apartment_number"
                            wovn-ignore
                            :disabled="selectedWebRadio"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">ご連絡先<br />メールアドレス</div>
                </td>
                <td class="data">
                  <div class="items-data" style="margin-top: 10px">
                    <div class="label-data"></div>
                    <div class="content-data">
                      <div class="flex gap-2 elements">
                        <span wovn-ignore> {{ info_person_form.email }} </span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">ご連絡先電話番号</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data"></div>
                    <div class="content-data">
                      <div class="flex gap-2 elements">
                        <span wovn-ignore> {{ info_person_form.tel }} </span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <a-divider />
        <div class="buttons flex gap-2 justify-center mt-4 mb-4">
          <button @click="$router.go(-1)" class="c-btn btn-white">
            <span class="">戻る</span>
          </button>
          <button @click="handleNext" class="c-btn btn-grey">
            <span class="">次へ</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { Step, Item, SectionContentTitle } from '@/components/compound'
import { GET_LOCATE, UPDATE_INFO_DETAIL } from '@/store/modules/bs_app/actions'
import locateData from '@/jsons-data/locate.json'
import func_utils from '@/mixins/func_utils'
import moment from 'moment'
import { Core as YubinBangoCore } from '@/utils/yubinbango-core2/yubinbango-core'
import { codes } from '@/constants/prefectures'

export default {
  mixins: [func_utils],
  components: {
    Step,
    Item,
    SectionContentTitle
  },
  data() {
    return {
      customerPlan: null,
      email: 0,
      phone: 0,
      isEditEmail: false,
      isEditPhone: false,
      myEmail: '',
      myPhone: 0,
      firstEmail: '',
      secondEmail: '',
      firstTel: '',
      secondTel: '',
      zipCode1: '',
      zipCode2: '',
      prefectures: '',
      cityAddress: '',
      apartment_number: '',
      titleContent: ['お申し込み内容', '申込者情報'],
      error_message: 'メールアドレスを入力してください',
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申請者情報を入力'
        },
        {
          id: 3,
          label: '補助金利用申請'
        },
        {
          id: 4,
          label: '申込内容確認'
        },
        {
          id: 5,
          label: '申込完了'
        }
      ],
      options: [],
      error_message_email: null,
      error_message_phone: null,
      error_message_zipcode: null,
      error_message_prefectures: null,
      error_message_cityAddress: null,
      hasError: false,
      info_person_form: {
        memberId: '',
        firstName: '',
        familyName: '',
        apartment_number: '',
        email: '',
        secondEmail: null,
        tel: '',
        secondTel: null
      },
      locate: locateData.locate,
      dataItemOrder: {},
      checkinTime: '',
      useCoupon: false,
      profileInfo: {},
      totalAdultPeople: 0,
      totalChildren: 0,
      textUnregister: '未登録',
      zipcodeError: false,
      isForeign: false,
      stayDay: null,
      nightCnt: null,
      stayRoom: null,
      totalAdult: null,
      totalChild: null
    }
  },
  mounted() {
    let orderData = _.get(this.$store.state, 'order.menuBasicInfo.menuNo', null)
    if (orderData === null) {
      this.$router.push("/interrupt")
      return
    }

    const infoPublicStay = this.$store.getters['order/get'].orderPublicStay
    this.stayDay = _.get(infoPublicStay, 'stayDateRoom.date', null)
      ? moment(_.get(infoPublicStay, 'stayDateRoom.date', null)).format(
          'YYYY年MM月DD日から'
        )
      : null
    this.nightCnt = _.get(infoPublicStay, 'stayDateRoom.stayNight', null)
    this.stayRoom = _.get(infoPublicStay, 'stayDateRoom.stayRoom', null)
    this.dataItemOrder = this.$store.getters['order/get'].dataItemPublicStay
    this.useCoupon = this.$store.getters.isUseCoupon
    this.useBenepoPoint = this.$store.getters.isUseBenepoPoint
    this.customerPlan = this.customerPlanState
    // this.getPlanBasicInfo()
    this.mountData()
    this.getProfileInfo()
    this.getTotalPeople()
    this.$nextTick(() => {
      this.$refs.zipCode1.focus();
    })
  },
  computed: {
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.getters, 'planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(_.get(this.$store.getters, 'customerPlan', null))
    },
    getInfoDetail() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.info_detail', null))
    },
    getDataBsApp02001() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.bs_app_02_001', null))
    },
    selectedWebRadio() {
      // ご利用案内書の受け取り方法 WEBプリント/郵送かで住所必須有無を制御する。
      return _.get(this.$store.getters, 'bs_app.selected_web_radio', null) === 1
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    getPrefecturesList() {
      const list = []
      const prefecturesList = Object.entries(codes)
      prefecturesList.forEach((item) => {
        list.push({ label: item[1].name, value: item[1].name })
      })
      return list
    },
    isForeignZipCode() {
      if (this.zipCode1 && this.zipCode2){
        return this.zipCode1 === '000' && this.zipCode2 === '0000'
      }
      else{
        return false
      }
    }
  },
  methods: {
    getTotalPeople() {
      const infoPublicStay = this.$store.getters['order/get'].orderPublicStay
      const peopleRoom = _.get(infoPublicStay, 'peopleRoom', '')
      this.totalAdult = 0
      this.totalChild = 0
      if (peopleRoom) {
        peopleRoom.forEach((element) => {
          this.totalAdult +=
            _.get(element, 'member.man', 0) +
            _.get(element, 'member.woman', 0) +
            _.get(element, 'visitors.man', 0) +
            _.get(element, 'visitors.woman', 0)
          this.totalChild +=
            _.get(element, 'children.childrenMember10', 0) +
            _.get(element, 'children.childrenMember15', 0) +
            _.get(element, 'children.childrenMember20', 0) +
            _.get(element, 'children.childrenMember30', 0) +
            _.get(element, 'children.childrenMember40', 0) +
            _.get(element, 'children.childrenMember50', 0) +
            _.get(element, 'children.childrenVisitor10', 0) +
            _.get(element, 'children.childrenVisitor15', 0) +
            _.get(element, 'children.childrenVisitor20', 0) +
            _.get(element, 'children.childrenVisitor30', 0) +
            _.get(element, 'children.childrenVisitor40', 0) +
            _.get(element, 'children.childrenVisitor50', 0)
        })
      }
    },
    mountData() {
      const bs_app_02_001 = this.getDataBsApp02001
      if (bs_app_02_001) {
        this.checkinTime = bs_app_02_001.checkinTime
        this.totalFee = bs_app_02_001.totalFee
        this.totalAdultPeople = bs_app_02_001.totalAdultPeople
        this.totalChildren = bs_app_02_001.totalChildren
      }
      const customerInfo = this.getInfoDetail ? this.getInfoDetail : null
      if (customerInfo) {
        this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
        this.info_person_form.firstName = customerInfo.firstName
        this.info_person_form.familyName = customerInfo.familyName
        this.info_person_form.email = customerInfo.email
        this.info_person_form.secondEmail = customerInfo.secondEmail
        this.info_person_form.tel = customerInfo.tel
        this.info_person_form.secondTel = customerInfo.secondTel
        if(!this.selectedWebRadio){
          this.zipCode1 = customerInfo.zipCode1
          this.zipCode2 = customerInfo.zipCode2
          this.prefectures = customerInfo.prefectures
          this.cityAddress = customerInfo.cityAddress
          this.info_person_form.apartment_number = customerInfo.apartment_number
          this.isForeign = customerInfo.isForeign
        }
      }
      this.checkiIsForeign()
    },
    checkiIsForeign() {
      if (this.isForeignZipCode) {
        this.isForeign = true
        this.hasError = false
        this.prefectures = ''
        this.cityAddress = ''
        this.info_person_form.apartment_number = ''
      }
    },
    getPlanBasicInfo() {
      const planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      const roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
      if (planBasicInfo && roomBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(this.getPlanInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: _.get(planBasicInfo, 'planImages[0].imageUrl', ''),
          title1: _.get(this.getPlanInfo, 'menuInformation.menuNm', ''),
          title2: _.get(planBasicInfo, 'planNm', '')
        }
      }
    },
    getProfileInfo() {
      const infoPublicStay = this.$store.getters['order/get'].orderPublicStay
      console.log(this.profileInfo)
      if (this.getInfoDetail === null) {
        this.profileInfo = _.get(infoPublicStay, 'profileInfo', null)
        if (this.profileInfo) {
          this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
          this.info_person_form.firstName = this.profileInfo.firstName
          this.info_person_form.familyName = this.profileInfo.familyName
          this.info_person_form.firstNameKana = this.profileInfo.firstNameKana
          this.info_person_form.familyNameKana = this.profileInfo.familyNameKana
          this.info_person_form.email = this.profileInfo.email
          this.info_person_form.secondEmail = this.profileInfo.secondEmail
          this.info_person_form.tel = this.profileInfo.tel
          this.info_person_form.secondTel = this.profileInfo.secondTel
          if(!this.selectedWebRadio){
            const postalCode = _.get(this.profileInfo, 'addresses[0].postalCode', '')
            if (postalCode) {
              this.zipCode1 = postalCode.substring(0, 3)
              this.zipCode2 = postalCode.substring(3, 7)
              this.getProfileMe()
              this.cityAddress = _.get(this.profileInfo, 'addresses[0].address1', '')
              this.info_person_form.apartment_number = _.get(
                this.profileInfo,
                'addresses[0].address2',
                ''
              )
              
            }
            this.isForeign = this.profileInfo.isForeign
          }
        }
        this.checkiIsForeign()
      }
    },
    getProfileMe() {
      const zipCode = `${this.zipCode1}${this.zipCode2}`
      if (this.zipCode1 && this.zipCode2) {
        new YubinBangoCore(zipCode, (data) => {
          if (data !== null) {
            this.prefectures = data.region ? data.region : undefined
          }
        })
      }
    },
    handleChangeEmail() {
      this.isEditEmail = false
      this.error_message_email = ''
    },
    handleChangePhone() {
      this.isEditPhone = false
      this.error_message_phone = ''
    },
    handleInputEmail() {
      this.isEditEmail = false
      if (this.email === 0) {
        this.myEmail = this.info_person_form.email
      } else {
        this.myEmail = this.info_person_form.secondEmail
      }
      return this.myEmail
    },
    saveMyEmail(myEmail) {
      this.myEmail = this.myEmail ? this.myEmail.trim() : this.myEmail
      if (this.validEmail(myEmail.trim())) {
        if (this.email === 0) {
          this.firstEmail = this.myEmail
          this.info_person_form.email = this.firstEmail
        } else {
          this.secondEmail = this.myEmail
          this.info_person_form.secondEmail = this.secondEmail
        }
        if (
          this.info_person_form.email === this.info_person_form.secondEmail ||
          this.info_person_form.secondEmail === this.info_person_form.email
        ) {
          this.hasError = true
          this.error_message_email =
            '入力したメールアドレスは既に存在しますので、再試行してください。'
        } else {
          this.isEditEmail = false
          this.error_message_email = ''
        }
      } else {
        this.hasError = true
        this.error_message_email = '有効なメールアドレスを入力してください'
        if (!this.myEmail) {
          this.error_message_email = 'メールアドレスを入力してください'
        }
      }
    },
    handleInputPhone() {
      this.isEditPhone = false
      if (this.phone === 0) {
        this.myPhone = this.info_person_form.tel
      } else {
        this.myPhone = this.info_person_form.secondTel
      }
      return this.myPhone
    },
    saveMyTel(myPhone) {
      if (this.validPhone(myPhone)) {
        if (this.phone === 0) {
          this.firstTel = this.myPhone
          this.info_person_form.tel = this.firstTel
        } else {
          this.secondTel = this.myPhone
          this.info_person_form.secondTel = this.secondTel
        }
        if (
          this.info_person_form.tel === this.info_person_form.secondTel ||
          this.info_person_form.secondTel === this.info_person_form.tel
        ) {
          this.isEditPhone = true
          this.hasError = true
          this.error_message_phone =
            '入力した電話番号は既に存在しますので、再試行してください'
          return
        } else {
          this.isEditPhone = false
          this.error_message_phone = ''
        }
        if (this.myPhone[0] === '0') {
          this.isEditPhone = false
          this.error_message_phone = ''
        } else {
          this.isEditPhone = true
          this.hasError = true
          this.error_message_phone = '有効な電話番号を入力してください'
        }
      } else {
        this.hasError = true
        this.error_message_phone = '有効な電話番号を入力してください'
        if (!this.myPhone) {
          this.error_message_phone = '電話番号を入力してください'
        }
      }
    },
    validateZipcodeInput() {
      this.zipCode1 = this.inputAge(this.zipCode1)
      this.zipCode2 = this.inputAge(this.zipCode2)
    },
    async loadLocation() {
      this.validateZipcodeInput()
      this.isForeign = false
      if (this.zipCode1 && this.zipCode2) {
        this.checkiIsForeign()
        if (this.isForeign) {
          return
        }
        if (this.zipCode1.length < 3 || this.zipCode2.length < 4) {
          this.zipcodeError = true
          this.hasError = true
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
          this.error_message_zipcode = '郵便番号の形式が正しくありません。'
        }
        const zipCode = `${this.zipCode1}${this.zipCode2}`
        if (zipCode.length > 6) {
          new YubinBangoCore(zipCode, (data) => {
            if (data !== null) {
              if (data.region_id) {
                this.zipcodeError = false
                this.error_message_zipcode = ''
              } else {
                this.zipcodeError = true
                this.hasError = true
                if (zipCode.length > 6) {
                  this.error_message_zipcode =
                    '郵便番号が存在しません。有効な郵便番号を入力してください'
                }
              }
              this.prefectures = data.region ? data.region : ''
              this.cityAddress = data.locality && data.street ? `${data.locality}${data.street}` : data.locality ? data.locality : ''
            }
            this.checkMessageError()
          })
        } else {
          this.checkMessageError()
        }
      } else {
        this.zipcodeError = false
        this.checkMessageError()
        this.prefectures = ''
        this.cityAddress = ''
      }
    },
    getLocation() {
      this.$store.dispatch(GET_LOCATE).then((data) => {
        this.locate = data.locate
      })
    },
    editEmail() {
      this.isEditEmail = true
    },
    editPhoneNumber() {
      this.myPhone = this.myPhone ? this.myPhone.replaceAll('-', '') : ''
      this.isEditPhone = true
    },
    CheckErrorMessagePhoneAndEmail() {
      this.textUnregister = ''
      this.hasError = false
      if (this.myEmail === '') {
        this.hasError = true
        this.error_message_email = 'メールアドレスを入力してください'
      } else {
        this.error_message_email = ''
      }
      if (this.myPhone === '') {
        this.hasError = true
        this.error_message_phone = '電話番号を入力してください'
      } else {
        this.error_message_phone = ''
      }
    },
    checkMessageError() {
      this.hasError = false
      if(this.selectedWebRadio) {
        return;
      }
      if (!this.prefectures) {
        this.hasError = true
        this.error_message_prefectures = '都道府県を入力してください'
      } else {
        this.error_message_prefectures = ''
      }
      if (!this.cityAddress || this.cityAddress.trim() === '') {
        this.hasError = true
        this.error_message_cityAddress = '市区町村・番地を入力してください'
      } else {
        this.error_message_cityAddress = ''
      }
      if (!this.zipcodeError) {
        if (this.zipCode1 === '' || this.zipCode2 === '') {
          this.hasError = true
          this.error_message_zipcode = '郵便番号を入力してください'
        } else {
          this.error_message_zipcode = ''
        }
      }
    },
    getPrefectureCode() {
      const prefIndex = [];
      console.log({a:this.getPrefecturesList,b:this.prefectures})
      this.getPrefecturesList.filter((prefectures, idx) => {
        if (prefectures.value == this.prefectures) {
          prefIndex.push(idx);
        }
        return prefectures.value == this.prefectures;
      });
      if (prefIndex && prefIndex.length == 1) {
        return (Number(prefIndex[0]) + 1).toString();
      }
      return "";
    },
    updateInfoDetail() {
      this.prefectureCode = this.getPrefectureCode();
      const info = {
        memberId: this.info_person_form.memberId,
        firstName: _.get(this.info_person_form, 'firstName', ''),
        familyName: _.get(this.info_person_form, 'familyName', ''),
        zipCode1: this.zipCode1,
        zipCode2: this.zipCode2,
        prefectures: this.prefectures,
        cityAddress: this.cityAddress ? this.cityAddress.trim() : this.cityAddress,
        apartment_number: _.get(this.info_person_form, 'apartment_number', ''),
        info_person: this.info_person,
        email: this.info_person_form.email,
        secondEmail: this.info_person_form.secondEmail,
        tel: this.info_person_form.tel,
        secondTel: this.info_person_form.secondTel,
        myEmail: this.myEmail,
        myPhone: this.myPhone,
        isForeign: this.isForeign,
        prefectureCode: this.prefectureCode
      }
      this.$store.dispatch(UPDATE_INFO_DETAIL, info).then(() => {})
    },
    gotoScreen(code) {
      const dataItemOrder = this.$store.getters['order/get'].dataItemPublicStay
      const menuNo = _.get(dataItemOrder, 'menu_id', '')
      switch (code) {
        case 1:
          this.$router.push({ path: '/', query: {} })
          return
        case 2:
          this.$router.push({
            path: `/public-stay/menus/${menuNo}`
          })
          return
        case 3:
          this.$router.push({
            path: '/public-stay/menus/register-rooms'
          })
      }
    },
    async handleNext() {
      const query = this.$route.query
      if (!this.isForeignZipCode) {
        this.checkMessageError()
      }
      this.updateInfoDetail()
      if (!this.hasError) {
        this.$router.push({ path: '/public-stay/menus/register-coupon', query })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
